import { render, staticRenderFns } from "./PT110_colorSizeModal.vue?vue&type=template&id=73fdc568&"
import script from "./PT110_colorSizeModal.vue?vue&type=script&lang=js&"
export * from "./PT110_colorSizeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports